import global_en from './global/en';
import global_es from './global/es';
import validation_en from './validation/en';
import validation_es from './validation/es';
import countries_en from './countries/en';
import countries_es from './countries/es';
import faq_en from './faq/en';
import faq_es from './faq/es';

export default {
    global: {
        en: global_en,
        es: global_es,
    },
    validation: {
        en: validation_en,
        es: validation_es,
    },
    countries: {
        en: countries_en,
        es: countries_es,
    },
    faq: {
        en: faq_en,
        es: faq_es,
    },
};
